import { ApplicationState } from '../AppReducer';
import { ISpace } from '../../shared/motive/models/Space';

export const selectSpaces = (app: ApplicationState): ISpace[] => app.spaces.spaces;
